import { render, staticRenderFns } from "./UpdateUserPasswordWindow.vue?vue&type=template&id=10d32f21"
import script from "./UpdateUserPasswordWindow.vue?vue&type=script&lang=js"
export * from "./UpdateUserPasswordWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports